import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { LabelListStatementType } from "../Labeling.types";

export function StatementTypeMenu({
    statementType,
    setStatementType,
}: {
    statementType: LabelListStatementType;
    setStatementType: (statementType: LabelListStatementType) => void;
}) {
    return (
        <div>
            <button
                className="quiet capitalize"
                onClick={() =>
                    setStatementType(
                        statementType === LabelListStatementType.BALANCE_SHEET
                            ? LabelListStatementType.INCOME_STATEMENT
                            : LabelListStatementType.BALANCE_SHEET,
                    )
                }
            >
                {statementType === LabelListStatementType.BALANCE_SHEET
                    ? "Balance Sheet"
                    : "Income Statement"}
                <ChevronDownIcon className="size-4" />
            </button>
        </div>
    );
}
